<template>
  <div class="container">
    <van-sticky>
      <PublicHeader :totalName="$t('bill').title" />
      <!-- 顶部 -->
      <div class="top">
        <!-- tab切换 -->
        <div class="tabs">
          <span v-for="(item, index) in tabs" :key="`tab${index}`" :class="active == item.value ? 'active' : ''" @click="changeTab(item.value)">{{ item.name }}</span>
        </div>
        <!-- 合约tab -->
        <!-- <div class="businesstabs" v-if="active == 'contract'">
          <span v-for="(item, index) in tabsBusiness" :key="`tabbus${index}`"
            :class="activeBusiness == item.value ? 'active' : ''" @click="changeBusinessTab(item.value)">{{ item.name
            }}</span>
        </div> -->
        <!-- 充值提现tab -->
        <!-- <div class="businesstabs" v-if="active == 'recharge' || active == 'withdrawal'">
          <span v-for="(item, index) in tabsCoin" :key="`tab${index}`" :class="activeCoin == item.value ? 'active' : ''" @click="changeCoinTab(item.value)">{{ item.name
            }}</span>
        </div> -->
        <!-- 币种类型筛选 -->
        <div class="seltabs">
          <div class="left">
            <span @click="showCoinSelect = true">{{ $t('bill').Currency }} <van-icon name="play" size="13" class="ric" color="var(--text_color)" /></span>
            <span @click="showTypeSelect = true" v-if="active == 'contract' || active == 'cion' || active == 'wallet' || active == 'finance'">{{
                $t('bill').type }} <van-icon name="play" size="13" class="ric" color="var(--text_color)" /></span>
          </div>
          <svg-icon class-name="svgs" icon-class="date" @click="showDateSelect = true" />
        </div>
      </div>
    </van-sticky>
    <!-- 列表 -->
    <div class="listInfo">
      <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getAllChangeLog" :immediate-check="false">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`bill${dIndex}`">
          <div class="info">
            <div class="left">
              <div class="name" v-if="dItem.businessName">{{ $t(`bill.${dItem.businessName}`) }}</div>
              <div class="name" v-if="dItem.status">{{ dItem.status == 1 ? $t('bill').audit :
                dItem.status == 2 ? $t('bill').success : dItem.status == 3 ? $t('bill').refuse : '' }}</div>
              <div class="time" v-if="dItem.applyTime">{{ dItem.applyTime | getLocalTime }}</div>
              <div class="time" v-else>{{ dItem.operTime | getLocalTime }}</div>
            </div>
            <!-- 充值提现 -->
            <div class="right" v-if="active == 'recharge' || active == 'withdrawal'">
              <!-- 提现 -->
              <div class="amount red" v-if="dItem.type == 2">-{{ dItem.amount }} {{ dItem.businessType ==
                2 ? 'USD' : dItem.currency.split('(')[0] }}</div>
              <!-- 充值 -->
              <div class="amount green" v-else>+{{ dItem.amount }} {{ dItem.businessType ==
                2 ? 'USD' : dItem.currency.split('(')[0] }}</div>
              <div class="balance" v-if="dItem.businessType == 2">{{ dItem.currencyAmount }} {{ dItem.currency }}</div>
              <div class="balance" v-else> {{ dItem.currency }}</div>
            </div>
            <!-- 余额 -->
            <div class="right" v-else>
              <div class="amount red" v-if="dItem.amount < 0">{{ dItem.amount }} {{ dItem.currency }}</div>
              <div class="amount green" v-else>+{{ dItem.amount }} {{ dItem.currency }}</div>
              <div class="balance" v-if="dItem.businessName != 'auth_reward'">{{ dItem.after }} {{ dItem.currency }}</div>
            </div>
          </div>
          <div class="order" v-if="dItem.tradeNo">{{ dItem.tradeNo }} <span @click="onCopy(dItem.tradeNo)">{{
            $t('public').copyTxt }}</span>
          </div>
        </div>
      </van-list>
      <div class="empty" v-if="isEmpty">
        <svg-icon class-name="esvgs" icon-class="empty" />
        <div class="txt">{{ $t('public').emptyTxt }}</div>
      </div>
    </div>
    <!-- 币种筛选 -->
    <van-popup v-model="showCoinSelect" position="bottom" closeable>
      <div class="selInfo">
        <div class="tit">{{ $t('bill').SelectCurrency }}</div>
        <div class="lable">{{ $t('bill').Currency }}</div>
        <div class="item">
          <span :class="coinSelect == item.currency ? 'active' : ''" @click="onSelectCoin(item.currency)" v-for="(item, index) in coinList" :key="`conl${index}`">{{ item.currency }}</span>
        </div>
        <div class="btns">
          <div class="btn" @click="coinReset">{{ $t('public').reset }}</div>
          <div class="btn" style="margin-left: 10px;" @click="coinConfirm">{{ $t('public').confirm }}</div>
        </div>
      </div>
    </van-popup>
    <!-- 类型筛选 -->
    <van-popup v-model="showTypeSelect" position="bottom" closeable>
      <div class="selInfo">
        <div class="tit">{{ $t('bill').SelectType }}</div>
        <div v-for="(item, index) in businessList" :key="`bussp${index}`">
          <div class="lable">{{ $t(`bill.${item.businessName}`) }}</div>
          <div class="item">
            <span v-for="(_item, _index) in item.child" :key="`bussc${_index}`" :class="typeSelect == _item.businessName ? 'active' : ''" @click="onSelectType(_item.businessName)">{{
                $t(`bill.${_item.businessName}`) }}</span>
          </div>
        </div>
        <div class="btns">
          <div class="btn" @click="typeReset">{{ $t('public').reset }}</div>
          <div class="btn" style="margin-left: 10px;" @click="typeConfirm">{{ $t('public').confirm }}</div>
        </div>
      </div>
    </van-popup>
    <!-- 日期筛选 -->
    <van-popup v-model="showDateSelect" position="bottom" closeable>
      <div class="dateSelInfo">
        <div class="tit">{{ $t('bill').SelectDate }}</div>
        <div class="dates">
          <div class="tt" :class="selectDateIndex == 0 ? 'active' : ''" @click="changeDate(0)">{{ startDate }}</div>
          <div>{{ $t('bill').to }}</div>
          <div class="tt" :class="selectDateIndex == 1 ? 'active' : ''" @click="changeDate(1)">{{ endDate }}</div>
        </div>
        <van-datetime-picker type="date" :show-toolbar="false" :min-date="minDate" :max-date="maxDate" v-if="selectDateIndex == 0" @input="changeStartDate" />
        <van-datetime-picker type="date" :show-toolbar="false" :min-date="minDate" :max-date="maxDate" v-if="selectDateIndex == 1" @input="changeEndDate" />
        <div class="btns">
          <div class="btn" @click="dateReset">{{ $t('public').reset }}</div>
          <div class="btn" style="margin-left: 10px;" @click="dateConfirm">{{ $t('public').confirm }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import userApi from '@/api/user'
import systemApi from '@/api/system'
import PublicHeader from '@/components/publicHeader'
import { getLocalDate } from '@/utils/validate'
export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      isEmpty: false,
      assetType: 1,
      minDate: new Date(2024, 0, 1),
      maxDate: new Date(),
      startDate: '',
      endDate: '',
      selectDateIndex: 0,
      showDateSelect: false,
      //类型选择
      typeSelect: null,
      showTypeSelect: false,
      businessList: [],
      //币种选择
      coinSelect: null,
      showCoinSelect: false,
      coinList: [],
      //tab类型
      active: "contract",
      tabs: [{
        "name": this.$t('bill').Contractfunds,
        "value": "contract"
      }, {
        "name": this.$t('bill').Spotfunds,
        "value": "cion"
      }, {
        "name": this.$t('bill').Walletfunds,
        "value": "wallet"
      }, {
        "name": this.$t('finance').financefund,
        "value": "finance"
      }, {
        "name": this.$t('bill').RechargeRecord,
        "value": "recharge"
      }, {
        "name": this.$t('bill').WithdrawalRecord,
        "value": "withdrawal"
      }],
      //合约分类
      activeBusiness: 1,
      tabsBusiness: [{
        name: this.$t('public').USDTcontract,
        value: 1
      }, {
        name: this.$t('public').Fiatcurrencycontract,
        value: 2
      }],
      //虚拟币法币
      activeCoin: 1,
      tabsCoin: [{
        name: this.$t('bill').virtualcoin,
        value: 1
      }, {
        name: this.$t('bill').Legaltender,
        value: 2
      }],
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      oList: [],
    }
  },
  mounted() {
    this.changeALL()
  },
  methods: {
    //切换全部事件
    changeALL() {
      if (this.active == 'contract')
        this.assetType = this.activeBusiness
      if (this.active == 'cion')
        this.assetType = 3
      if (this.active == 'wallet')
        this.assetType = 4
      if (this.active == 'finance')
        this.assetType = 5
      if (this.active == 'recharge' || this.active == 'withdrawal') {
        if (this.activeCoin == 1)
          this.getCurrencyNetworkSetting()
        if (this.activeCoin == 2)
          this.getRateList()
      } else {
        this.getAssetBusiness()
        this.getAssetWalletCurrency()
      }
      this.oList = []
      this.parms.pageNum = 1
      this.finished = false;
      this.getAllChangeLog()
    },
    //获取系统币种
    async getCurrencyNetworkSetting() {
      const res = await systemApi.getCurrencyNetworkSetting()
      this.coinList = res.currencyArr.split(',').map(item => ({ currency: item }))
    },
    getAllChangeLog() {
      if (this.active == 'recharge' || this.active == 'withdrawal') {
        this.getRechargeWithdrawalLog()
      } else this.getAssetChangeLog()
    },
    // 切换Tab
    changeTab(val) {
      this.active = val
      this.typeSelect = ''
      this.coinSelect = ''
      this.startDate = ''
      this.endDate = ''
      this.changeALL()
    },
    //切换合约分类
    changeBusinessTab(val) {
      this.activeBusiness = val
      this.typeSelect = ''
      this.coinSelect = ''
      this.startDate = ''
      this.endDate = ''
      this.changeALL()
    },
    //选择币种
    onSelectCoin(val) {
      this.coinSelect = val
    },
    //币种确认
    coinConfirm() {
      this.showCoinSelect = false
      this.changeALL()
    },
    //币种重置
    coinReset() {
      this.coinSelect = ''
      this.showCoinSelect = false
      this.changeALL()
    },
    //选择类型
    onSelectType(val) {
      this.typeSelect = val
    },
    //类型确认
    typeConfirm() {
      this.showTypeSelect = false
      this.changeALL()
    },
    //类型重置
    typeReset() {
      this.typeSelect = ''
      this.showTypeSelect = false
      this.changeALL()
    },
    //日期选择
    changeDate(val) {
      this.selectDateIndex = val
    },
    // 开始日期
    changeStartDate(val) {
      if (val) this.startDate = getLocalDate(val)
    },
    // 结束日期
    changeEndDate(val) {
      if (val) this.endDate = getLocalDate(val)
    },
    //日期确认
    dateConfirm() {
      this.showDateSelect = false
      this.changeALL()
    },
    //日期重置
    dateReset() {
      this.startDate = ''
      this.endDate = ''
      this.showDateSelect = false
      this.changeALL()
    },
    // 获取币种
    async getAssetWalletCurrency() {
      const res = await userApi.getAssetWalletCurrency({ assetType: this.assetType })
      this.coinList = res.data
    },
    // 获取货币汇率
    async getRateList() {
      const res = await systemApi.getRateList()
      var list = res.rate
      list.forEach((sItem) => {
        sItem.currency = sItem.text
      })
      this.coinList = list
    },
    // 获取类型
    async getAssetBusiness() {
      var assetType = 1
      if (this.active == 'contract')
        assetType = this.activeBusiness
      else if (this.active == 'cion')
        assetType = 3
      else if (this.active == 'wallet')
        assetType = 4
      else if (this.active == 'finance')
        assetType = 5
      else return
      const res = await userApi.getAssetBusiness({ assetType: assetType })
      this.businessList = res.data
    },
    // 获取资金明细
    async getAssetChangeLog() {
      if (this.isRun) return
      this.isEmpty = false
      this.isRun = true
      this.parms.assetType = this.assetType
      this.parms.businessName = this.typeSelect
      this.parms.currency = this.coinSelect
      this.parms.startDate = this.startDate
      this.parms.endDate = this.endDate
      const res = await userApi.getAssetChangeLog(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      if (this.oList.length == 0) {
        this.isEmpty = true
      } else {
        this.isEmpty = false
      }
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
    },
    // 查询充值提现记录
    async getRechargeWithdrawalLog() {
      if (this.isRun) return
      this.isRun = true
      this.parms.businessType = this.activeCoin
      this.parms.type = this.active == 'recharge' ? 1 : 2
      this.parms.currency = this.coinSelect
      this.parms.startDate = this.startDate
      this.parms.endDate = this.endDate
      const res = await userApi.getRechargeWithdrawalLog(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
    },
    //切换虚拟币法币
    changeCoinTab(val) {
      this.activeCoin = val
      this.changeALL()
    },
    //复制方法
    onCopy(text) {
      return new Promise((resolve) => {
        if (navigator.clipboard?.writeText) {
          this.$toast(this.$t('public').copySuccess)
          return resolve(navigator.clipboard.writeText(text))
        }
        const textarea = document.createElement('textarea')
        document.body.appendChild(textarea)
        textarea.style.position = 'absolute'
        textarea.style.clip = 'rect(0 0 0 0)'
        textarea.value = text
        textarea.select()
        document.execCommand('copy', true)
        textarea.remove()
        this.$toast(this.$t('public').copySuccess)
        return resolve(true)
      })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);

  .top {
    padding-top: 50px;
    width: 100%;
    background: var(--background_color);

    .tabs {
      padding: 0 15px;
      font-size: 14px;
      font-weight: bold;
      color: var(--ntext_color);
      border-bottom: 1px solid var(--info_color);
      width: 100%;
      overflow-x: auto;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      -ms-overflow-style: none;

      span {
        display: inline-block;
        text-align: center;
        padding: 12px 0;
        margin-right: 15px;
      }

      .active {
        color: var(--text_color);
        padding-bottom: 10px;
        border-bottom: 2px solid var(--text_color);
      }
    }

    .businesstabs {
      display: flex;
      align-items: center;
      color: var(--ntext_color);
      font-size: 13px;
      padding: 8px 15px;
      border-bottom: 1px solid var(--info_color);

      span {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px 10px;
        margin-right: 10px;
      }

      .active {
        background: var(--info_color);
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px 10px;
        color: var(--text_color);
      }
    }

    .seltabs {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 11px 15px;
      border-bottom: 1px solid var(--info_color);
      color: var(--text_color);
      font-size: 13px;

      span {
        margin-right: 15px;
      }

      .ric {
        transform: rotate(90deg);
      }

      .svgs {
        width: 17px;
        height: 17px;
        color: var(--text_color);
      }
    }
  }

  .listInfo {
    margin: 0 15px 30px 15px;

    .item {
      margin-top: 30px;

      .info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
          .name {
            font-size: 14px;
            color: var(--text_color);

            span {
              margin-left: 10px;
              font-size: 12px;
              color: var(--ntext_color);
            }
          }

          .time {
            margin-top: 10px;
            font-size: 12px;
            color: var(--ntext_color);
          }
        }

        .right {
          text-align: right;

          .amount {
            font-size: 14px;
          }

          .balance {
            margin-top: 10px;
            font-size: 12px;
            color: var(--ntext_color);
          }
        }
      }

      .order {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        font-size: 12px;
        color: var(--ntext_color);

        span {
          color: var(--text_color);
        }
      }
    }
    .empty {
      margin-top: 50px;
      text-align: center;
      .esvgs {
        width: 50px;
        height: 50px;
      }
      .txt {
        margin-top: 30px;
        font-size: 12px;
        color: var(--text_color);
      }
    }
  }

  .selInfo {
    padding: 15px;

    .tit {
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: var(--text_color);
    }

    .lable {
      margin-top: 20px;
      font-size: 13px;
      color: var(--text_color);
    }

    .item {
      display: flex;
      flex-wrap: wrap;

      span {
        margin-top: 10px;
        padding: 10px;
        border: 1px solid var(--info_color);
        border-radius: 5px;
        font-size: 13px;
        color: var(--text_color);
        margin-right: 10px;
      }

      .active {
        background: var(--info_color);
      }
    }

    .btns {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .btn {
        width: 50%;
        height: 40px;
        background: var(--info_color);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: bold;
        color: var(--text_color);
        border-radius: 20px;
      }
    }
  }

  .dateSelInfo {
    .tit {
      padding: 15px 0;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: var(--text_color);
    }

    .dates {
      padding: 15px 50px;
      border: 1px solid var(--info_color);
      font-size: 13px;
      color: var(--ntext_color);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .tt {
        min-width: 100px;
        min-height: 15px;
        text-align: center;
      }

      .active {
        font-weight: bold;
        color: var(--text_color);
      }
    }

    .btns {
      margin: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .btn {
        width: 50%;
        height: 40px;
        background: var(--info_color);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: bold;
        color: var(--text_color);
        border-radius: 20px;
      }
    }
  }
}

::v-deep .van-popup--bottom {
  border-radius: 10px 10px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup__close-icon {
  font-size: 15px;
  color: var(--ntext_color);
}

::v-deep .van-picker {
  color: var(--text_color);
  background: var(--background_color);
}

::v-deep .van-picker__mask {
  background: none;
}

::v-deep .van-picker-column__item {
  color: var(--ntext_color);
}

::v-deep .van-picker-column__item--selected {
  color: var(--text_color);
}
</style>
